import { useMutation } from '@apollo/client';
import Button from "components/Button/Button";
import { InfoIcon } from 'components/Icons/Info';
import AfterPayInfo from 'components/Others/AfterPayInfo';
import ZipPayInfo from 'components/Others/ZipPayInfo';
import Spinner from 'components/Spinner/Spinner';
import { AttributeSelectedType, CompositeComponentType, CompositeFramePartsVariationType, CompositeLensVariationType } from 'constants/dataTypes';
import { frameSizeConst } from 'constants/frameSize';
import { getLocalCurrency } from 'functions/currency';
import { getArmVariation, getFrameVariation } from 'functions/getVariations';
import { stringToSlug } from 'functions/slug';
import { CREATE_CART } from 'gqlStrings/mutations/addToCart';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, setPeopleAlsoBoughtModal } from 'redux/features/bag/bagSlice';
import { addToCart } from 'redux/features/cart/cartSlice';
import { RootState } from 'redux/store';
import { showWarningMessage } from 'utils/toast.util';
import { useGlassesStore } from 'zus/glassesStore';
import * as ga from '../../lib/ga';
import { getSession } from 'functions/session';
import Image from 'next/image';
import LeftCircleArrow from 'components/Icons/LeftCircleArrow';
import Link from 'next/link';
import { parseAsString } from 'nuqs';
import { useQueryState } from 'nuqs';
import { wcApiDataService } from 'functions/wcApi';



export default function DresdenGOAddToCartComponent(
    { category, frameColor, checkVariationOnColorPicker, selectedVariations }: { category: string; frameColor: string; checkVariationOnColorPicker?: Function; selectedVariations: AttributeSelectedType; }) {
    const isLoad = useSelector((state: RootState) => state.bagEvent.loading);
    const dispatch = useDispatch();

    //const isSunglasses = category ? category.toString().toLowerCase().includes('sunglasses') : false;

    const [frameShapeQuery, setFrameShapeQuery] = useQueryState('shape', parseAsString.withDefault('classic'));
    const [armColorQuery, setArmColorQuery] = useQueryState('armColor', parseAsString.withDefault(frameColor));

    //const [lensColorQuery, setLensColorQuery] = useQueryState('lensColor', parseAsString.withDefault(isSunglasses ? 'grey' : 'clear'));

    const variationData = selectedVariations && selectedVariations['attribute_pa_power'] ? selectedVariations['attribute_pa_power'].variation : null;
    const price = selectedVariations && selectedVariations['attribute_pa_power'] ? selectedVariations['attribute_pa_power'].variation.meta.price : 0;
    //Zustand states
    const updateData = useGlassesStore((state) => state.updateData);


    const frameSizeZ = useGlassesStore((state) => state.frame_size)
    const armsColorZ = armColorQuery || frameColor;
    const armsSizeZ = useGlassesStore((state) => state.arms_size)

    const getRegularSize = (size: string, isFrame: boolean) => {
        let sizeTitle: string | undefined;
        frameSizeConst.forEach((frameSize: any) => {
          if (frameSize.short === size) {
            sizeTitle = frameSize.slug;
          }
        });
    
        if (isFrame && frameShapeQuery.toLowerCase() === 'round') {
          switch (sizeTitle!) {
            case 'small':
              return 'rounds';
            case 'medium':
              return 'roundm';
            case 'large':
              return 'roundl';
            default:
              return sizeTitle; // This will handle 'extra-small' or any other sizes
          }
        }
    
        return stringToSlug(sizeTitle);
      }


    const router = useRouter();

    const getAttributeList = (variation: CompositeLensVariationType) => {
        const attributes: Record<string, string> = Object.entries(variation.meta).reduce((acc, [key, value]) => {
            if (key.startsWith('attribute_pa_')) {
                if (key == 'attribute_pa_frame_shape') {
                    acc['attribute_pa_frame-shape'] = frameShapeQuery;
                } else {
                    acc[key] = value as string;
                }
            }
            return acc;
        }
            , {} as Record<string, string>); // Add index signature to the attributes object
        return attributes;
    }
    if (variationData) {
        console.log('getAttributeList(variationData)', getAttributeList(variationData));
    }

    const addToCartData = async () => {

        if (!variationData) {
            //showWarningMessage('This variation is not available', false);
            return;
        }
        const productDetailPageData: any = await wcApiDataService('glasses/' + category, '', router.locale);

        const glassesProduct = productDetailPageData?.components;

        const frame_products = glassesProduct.Frame;
        const arm_products = glassesProduct.Arms;
        const lens_products = glassesProduct.Lens;

        const composite_id = glassesProduct.Frame.composite_id;

        const arm_databaseId: string = glassesProduct.Arms.component_id;
        const frame_databaseId: string = glassesProduct.Frame.component_id;
        const lens_databaseId: string = glassesProduct.Lens.component_id;

        const frameSizeVariationName = frameShapeQuery == 'classic' ? frameSizeZ : frameShapeQuery.toLowerCase() + frameSizeZ.toLowerCase();

        //console.log('frameSizeZ', frameSizeZ);
        //console.log('frameColor', frameColor);
        //console.log('frameShapeQuery', frameShapeQuery);
        //console.log('armsColorZ', armsColorZ);
        //console.log('armsSizeZ', armsSizeZ);
        const arm_variation: CompositeFramePartsVariationType | undefined = getArmVariation(arm_products!, armsColorZ, armsSizeZ);
        const frame_variation: CompositeFramePartsVariationType | undefined = getFrameVariation(frame_products!, frameColor, frameSizeVariationName);
        //console.log('frame_variation', frame_variation);
        //console.log('arm_variation', arm_variation);
        if (arm_variation == undefined || frame_variation == undefined) {
            showWarningMessage('This variation is not available', false);
            return;
        }

        //console.log('lens_products?.products', lens_products?.products);
        //console.log('variationData', variationData);
        const extra_data: any = {
            [arm_databaseId]: {
                product_id: arm_products?.product.product_id,
                quantity: 1,
                optional_selected: 'yes',
                variation_id: arm_variation.variation_id,
                region_product_id: arm_variation.meta.region_product_ids,
                attributes: {
                    attribute_pa_color: armsColorZ,
                    attribute_pa_size: getRegularSize(armsSizeZ, false)
                },
                quantity_min: 1,
                quantity_max: 1,
                discount: '',
                optional: 'no',
                static: 'yes',
                title: 'Arms',
                composite_id,
                type: 'variable'
            },
            [frame_databaseId]: {
                product_id: frame_products?.product.product_id,
                quantity: 1,
                optional_selected: 'yes',
                variation_id: frame_variation.variation_id,
                region_product_id: frame_variation.meta.region_product_ids,
                attributes: {
                    attribute_pa_color: frameColor,
                    attribute_pa_size: getRegularSize(frameSizeZ, true)
                },
                quantity_min: 1,
                quantity_max: 1,
                discount: '',
                optional: 'no',
                static: 'yes',
                title: 'Frame',
                composite_id,
                type: 'variable'
            },
            [lens_databaseId]: {
                product_id: lens_products?.products[0].product_id,
                quantity: 1,
                optional_selected: 'yes',
                variation_id: variationData.variation_id,
                region_product_id: variationData.meta.region_product_ids,
                //get attributes from variationData.meta
                attributes: getAttributeList(variationData),
                quantity_min: 1,
                quantity_max: 1,
                discount: '',
                optional: 'no',
                static: 'yes',
                title: 'Lens',
                composite_id,
                type: 'variable',
            }
        };


        var cartData;
        if (updateData) {
            cartData = {
                variables: {
                    input: {
                        removeItem: updateData.key,
                        productId: composite_id,
                        clientMutationId: getSession(),
                        quantity: updateData.quantity,
                        extraData: JSON.stringify(extra_data),
                    }
                }
            };
        } else {
            cartData = {
                variables: {
                    input: {
                        clientMutationId: getSession(),
                        extraData: JSON.stringify(extra_data),
                        productId: composite_id,
                        quantity: 1,
                    }
                }
            };
        }

        dataLayer();

        return cartData;
    }

    const dataLayer = () => {
        ga.addDataLayer({
            event: 'addToCart',
            ecommerce: {
                currencyCode: getLocalCurrency(router.locale),
                add: {
                    products: [
                        {
                            name: 'Frame' + ' - ' + frameColor,
                            variant: frameColor,
                            price: price,
                            category: 'Frames',
                            quantity: 1
                        }
                    ]
                }
            }
        });
    }

    const [mutateCreateCart] = useMutation(CREATE_CART, {
        context: { clientName: 'laravel' }
    });

    const addToCartClick = async () => {
        dispatch(setPeopleAlsoBoughtModal(true));
        const session = getSession();
        if (!session) {
            mutateCreateCart({
                variables: {
                    input: {
                        isEmpty: true
                    }
                }
            }).then(() => {
                setTimeout(() => {
                    addToCartClick();
                }, 250);
            });
            return;
        }
        dispatch(setLoading(true));
        try {
            const cartData = await addToCartData();
            dispatch(addToCart(cartData));
        } catch (error) {
            console.error("Error adding to cart:", error);
            // Handle the error appropriately, e.g., show an error message to the user
        } finally {
            //   dispatch(setLoading(false));
        }
    }


    const getHashSlugFromColorSize = (size: string, color: string) => {
        const slug = `${color}`.toLowerCase().split(' ').join('-') + size;
        return slug;
    };



    const isSelectedVariationAvailable = useMemo(() => {

        if (checkVariationOnColorPicker) {
            const armColor = armColorQuery ? armColorQuery : frameColor;
            const frame_check = checkVariationOnColorPicker(armColorQuery ? 'Frame' : 'both', frameSizeZ, frameColor);
            const arms_check = checkVariationOnColorPicker('Arms', armsSizeZ, armColor);
            if (frame_check && arms_check) {
                return true;
            }
        }
        return false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frameSizeZ, frameColor, armsSizeZ, armColorQuery]);

    if (!isSelectedVariationAvailable) {
        return (<div className="flex max-w-[308px] mt-[24px] bg-[#fef4cb] items-center gap-[8px] px-[16px] py-[17px]">
            <InfoIcon />
            <p className="text-[14px] leading-[15px] text-[#616161]">
                This product is not available right now
            </p>
        </div>)
    } else {
        return (
            <>
                <Button
                    onClick={addToCartClick}
                    disabled={!price || price <= 0}
                    className="mt-4 w-full justify-center bg-brand-black50 !px-6 text-center mdx:sticky mdx:bottom-3"
                    textClass="font-medium text-white text-sm">
                    <span className="flex items-center">
                        {isLoad && (
                            <span className="mr-2 mt-[1px]">
                                <Spinner fill="white" />
                            </span>
                        )}{' '}
                        <span>
                            {updateData ? 'Update cart' : 'Add to cart'}
                            {(price && price > 0) ? (` $${price}`) : ''}
                        </span>
                    </span>
                </Button>

                <div className='mt-[24px] flex w-full gap-[10px]'>
                    <div className='w-[58px] h-[58px] bg-[#F9F9F9] rounded-[6px] px-[7px] py-[18px] flex-shrink-0 min-w-[58px]'>
                        <Image
                            src="/images/reading-glasses-change.png"
                            alt="Reading Glasses"
                            width={100}
                            height={20}
                            quality={92}
                        />
                    </div>
                    <div className='w-full'>
                        <p className='text-[13px] text-[#2A2A2A] leading-4'>You can <b>{router.locale == 'ca' ? 'customize' : 'customise'} your reading glasses with prescription lenses</b> to meet your specific vision needs.</p>
                        <div className='flex gap-[10px] mt-[6px] md:flex-row flex-col justify-center items-start md:justify-start'>
                            <Link href='/shop/prescription-glasses'>
                                <div className='flex justify-center items-center gap-[4px]'>
                                    <LeftCircleArrow />
                                    <p className='text-[13px] text-[#00AEC7] font-bold'>Prescription Glasses</p>
                                </div>
                            </Link>

                            <Link href='/shop/prescription-sunglasses'>
                                <div className='flex justify-center items-center gap-[4px]'>
                                    <LeftCircleArrow />
                                    <p className='text-[13px] text-[#00AEC7] font-bold'>Prescription Sunglasses</p>
                                </div>
                            </Link>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}
